import {otto, defineEvent} from "@otto-ec/global-resources/nexus";
import "./ActivationSlider.svelte";

otto.ft9.benefit.components.activationSlider.assignNamespace({
    activate: defineEvent(),
});